import { motion } from 'framer-motion';
import Badge from '~/components/Badge';

const Feature2 = () => {
	return (
		<section className="container-lp mx-auto flex flex-col flex-wrap items-center justify-center gap-10" id="features">
			<div className="card-bg relative z-20 flex w-full flex-col !bg-[#080720] py-10 lg:px-20 lg:py-20">
				<div className="mx-auto flex max-w-6xl flex-col gap-6 px-1 pb-10 lg:pb-20">
					<h2 className="text-transparent mx-auto bg-clip-text text-center text-2xl font-extrabold sm:text-4xl lg:text-5xl lg:leading-[60px]">
						<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
							Full support{' '}
						</span>
						<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
							for your dropshipping success: winning products, unbeatable product pages and captivating ads
						</span>
					</h2>

					<div className="mx-auto max-w-2xl text-center text-lg text-white lg:text-xl">
						PagePilot.ai supports you with more than just product pages. We're invested in helping you scale and grow
						your profits.
					</div>
				</div>

				<div className="flex flex-col">
					<div className="grid items-center gap-16 md:grid-cols-2">
						<div className="relative overflow-hidden rounded-2xl p-[4px]">
							<div className="card-bg p-3">
								<div className="relative h-full w-full overflow-hidden rounded-2xl p-[4px]">
									<div className="absolute inset-0 h-full w-full animate-rotate rounded-full bg-[conic-gradient(#05b574_20deg,transparent_120deg)]"></div>
									<div className="relative flex w-full flex-col gap-4 rounded-2xl border-[4px] border-black bg-gradient-to-b from-white from-70% to-slate-100 px-6 py-8">
										<div className="w-fit border-spacing-6 border-b-[3px] border-dotted font-inter text-lg font-semibold">
											Online store conversion rate
										</div>

										<div className="flex items-center justify-between">
											<motion.div
												className="font-inter text-2xl font-semibold sm:text-3xl"
												initial={{ scale: 1 }}
												animate={{ scale: 1.5 }}
												transition={{ duration: 1, repeat: Infinity, repeatType: 'reverse' }}>
												7.3%
											</motion.div>

											<div className="flex items-center gap-1 font-inter text-xl font-medium tracking-tighter text-green-500 sm:text-2xl">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													className="h-5 w-5 fill-green-500 sm:h-7 sm:w-7"
													viewBox="0 0 256 256">
													<path d="M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z"></path>
												</svg>
												23%
											</div>
										</div>

										<div className="hidden font-inter text-sm font-semibold uppercase tracking-tight sm:flex">
											Conversion Funnel
										</div>

										<div className="flex flex-col gap-4">
											<div className="flex flex-col justify-between gap-4 sm:flex-row sm:gap-0">
												<div className="flex flex-col gap-1">
													<div className="font-inter font-medium">Added to cart</div>
													<div className="font-inter text-sm font-medium text-gray-DEFAULT-500">9234 sessions</div>
												</div>
												<div className="flex gap-10">
													<div className="font-inter font-medium">17.1%</div>
													<div className="flex w-fit gap-1 font-inter font-medium">
														<svg
															xmlns="http://www.w3.org/2000/svg"
															className="relative top-[1px] h-[18px] w-[18px] fill-green-500"
															viewBox="0 0 256 256">
															<path d="M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z"></path>
														</svg>
														5%
													</div>
												</div>
											</div>
											<div className="flex flex-col justify-between gap-4 sm:flex-row sm:gap-0">
												<div className="flex flex-col gap-1">
													<div className="font-inter font-medium">Reached checkout</div>
													<div className="font-inter text-sm font-medium text-gray-DEFAULT-500">6100 sessions</div>
												</div>
												<div className="flex gap-10">
													<div className="font-inter font-medium">11.3%</div>
													<div className="flex w-fit gap-1 font-inter font-medium">
														<svg
															xmlns="http://www.w3.org/2000/svg"
															className="relative top-[1px] h-[18px] w-[18px] fill-green-500"
															viewBox="0 0 256 256">
															<path d="M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z"></path>
														</svg>
														4%
													</div>
												</div>
											</div>
											<div className="flex flex-col justify-between gap-4 sm:flex-row sm:gap-0">
												<div className="flex flex-col gap-1">
													<div className="font-inter font-medium">Sessions converted</div>
													<div className="font-inter text-sm font-medium text-gray-DEFAULT-500">3948 sessions</div>
												</div>
												<div className="flex gap-10">
													<div className="font-inter font-medium">7.%</div>
													<div className="flex w-fit gap-1 font-inter font-medium">
														<svg
															xmlns="http://www.w3.org/2000/svg"
															className="relative top-[1px] h-[18px] w-[18px] fill-green-500"
															viewBox="0 0 256 256">
															<path d="M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z"></path>
														</svg>
														3%
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="flex flex-col space-y-6 px-4">
							<Badge type="theme" extra="w-fit" text="High Conversion Pages" />
							<div className="text-2xl font-semibold text-white md:text-3xl">
								Dominate conversions by tapping customer psychology
							</div>
							<p className="text-base text-gray-DEFAULT-400 md:text-lg">
								PagePilot.ai uses advanced psychological triggers to create product pages that connect powerfully with
								your audience, compelling them to act.
							</p>
							<ul className="flex flex-col gap-6">
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Appeal to your customers' core desires
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Create a sense of urgency to encourage purchases
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Establish trust and credibility through messaging
									</span>
								</li>
							</ul>
						</div>
					</div>

					<div className="mt-20 grid items-center gap-20 lg:mb-28 lg:mt-28 lg:grid-cols-2 lg:gap-0">
						<div className="order-2 flex flex-col space-y-6 px-4 md:order-1">
							<Badge type="theme" extra="w-fit" text="Product Research Tool" />
							<div className="text-2xl font-semibold text-white md:text-3xl">
								Unlock 10 new winning products every day
							</div>
							<p className="text-base text-gray-DEFAULT-400 md:text-lg">
								We scrape Ads Manager daily to find top-performing products. You get these products with ready-to-use
								ads, all set for easy import into your store.
							</p>
							<ul className="flex flex-col gap-6">
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Discover winning products before they get saturated
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Import competitor's products directly to your Shopify store
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Quickly add new, winning products to your store
									</span>
								</li>
							</ul>
						</div>

						<div
							className="relative order-1 mx-auto flex h-full w-full max-w-[800px] flex-col items-center justify-center md:order-2"
							id="winning-products">
							<div className="flex w-full items-center justify-center">
								<div className="research-radar-scanner absolute z-20  h-[95%] min-w-[95%] rounded-full"></div>
								<img
									src="images/landingpage/radar.webp"
									className="w-full object-cover mix-blend-lighten"
									alt="Dropshipping Products Radar"
									width="800"
									height="800"
								/>
							</div>

							<div className="animated-product1 card-bg absolute left-[120px] top-[230px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0 sm:top-[280px]">
								<img
									src="/images/landingpage/productResearch1.webp"
									className="w-full max-w-[50px] sm:max-w-[80px]"
									alt="Dropshipping Winning Product"
									width="300"
									height="300"
								/>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-blue-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M240,56v64a8,8,0,0,1-13.66,5.66L200,99.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31,29.66,189.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0L136,140.69,188.69,88,162.34,61.66A8,8,0,0,1,168,48h64A8,8,0,0,1,240,56Z"></path>
									</svg>
									<span className="text-md uppercase text-blue-300 sm:text-sm">Winning</span>
								</div>
							</div>

							<div className="animated-product2 card-bg absolute left-[280px] top-[190px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0 sm:top-[280px]">
								<img
									src="/images/landingpage/productResearch2.webp"
									className="w-full max-w-[50px] sm:max-w-[80px]"
									alt="Dropshipping Winning Product"
									width="300"
									height="300"
								/>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M103.77,185.94C103.38,187.49,93.63,224,40,224a8,8,0,0,1-8-8c0-53.63,36.51-63.38,38.06-63.77a8,8,0,0,1,3.88,15.53c-.9.25-22.42,6.54-25.56,39.86C81.7,204.48,88,183,88.26,182a8,8,0,0,1,15.51,4Zm93-67.4L192,123.31v58.33A15.91,15.91,0,0,1,187.32,193L153,227.3A15.91,15.91,0,0,1,141.7,232a16.11,16.11,0,0,1-5.1-.83,15.94,15.94,0,0,1-10.78-12.92l-5.37-38.49L76.24,135.55l-38.47-5.37A16,16,0,0,1,28.7,103L63,68.68A15.91,15.91,0,0,1,74.36,64h58.33l4.77-4.77c26.68-26.67,58.82-27.82,71.41-27.07a16,16,0,0,1,15,15C224.6,59.71,223.45,91.86,196.78,118.54ZM116.69,80H74.36L40,114.34l37.15,5.18ZM176,139.31l-39.53,39.53L141.67,216,176,181.64Z"></path>
									</svg>
									<span className="text-md uppercase text-green-400 sm:text-sm">Scaling</span>
								</div>
							</div>

							<div className="animated-product3 card-bg absolute right-[300px] top-[80px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0">
								<div className="py-2">
									<img
										src="/images/landingpage/productResearch3.webp"
										className="w-full max-w-[50px] sm:max-w-[50px]"
										alt="Dropshipping Winning Product"
										width="300"
										height="300"
									/>
								</div>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M103.77,185.94C103.38,187.49,93.63,224,40,224a8,8,0,0,1-8-8c0-53.63,36.51-63.38,38.06-63.77a8,8,0,0,1,3.88,15.53c-.9.25-22.42,6.54-25.56,39.86C81.7,204.48,88,183,88.26,182a8,8,0,0,1,15.51,4Zm93-67.4L192,123.31v58.33A15.91,15.91,0,0,1,187.32,193L153,227.3A15.91,15.91,0,0,1,141.7,232a16.11,16.11,0,0,1-5.1-.83,15.94,15.94,0,0,1-10.78-12.92l-5.37-38.49L76.24,135.55l-38.47-5.37A16,16,0,0,1,28.7,103L63,68.68A15.91,15.91,0,0,1,74.36,64h58.33l4.77-4.77c26.68-26.67,58.82-27.82,71.41-27.07a16,16,0,0,1,15,15C224.6,59.71,223.45,91.86,196.78,118.54ZM116.69,80H74.36L40,114.34l37.15,5.18ZM176,139.31l-39.53,39.53L141.67,216,176,181.64Z"></path>
									</svg>
									<span className="text-md uppercase text-green-400 sm:text-sm">Scaling</span>
								</div>
							</div>

							<div className="animated-product4 card-bg absolute right-[200px] top-[180px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0">
								<div className="py-2">
									<img
										src="/images/landingpage/productResearch4.webp"
										className="w-full max-w-[50px] sm:max-w-[50px]"
										alt="Dropshipping Winning Product"
										width="300"
										height="300"
									/>
								</div>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M232,208H213.69L153.42,34.75A16,16,0,0,0,138.31,24H117.69a16,16,0,0,0-15.11,10.74L42.31,208H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM95.43,104h65.14l16.7,48H78.73Z"></path>
									</svg>
									<span className="text-md uppercase text-yellow-400 sm:text-sm">Scaling</span>
								</div>
							</div>

							<div className="animated-product5 card-bg absolute right-[100px] top-[260px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0">
								<img
									src="/images/landingpage/productResearch5.webp"
									className="w-full max-w-[50px] sm:max-w-[55px]"
									alt="Dropshipping Winning Product"
									width="300"
									height="300"
								/>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-blue-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M240,56v64a8,8,0,0,1-13.66,5.66L200,99.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31,29.66,189.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0L136,140.69,188.69,88,162.34,61.66A8,8,0,0,1,168,48h64A8,8,0,0,1,240,56Z"></path>
									</svg>
									<span className="text-md uppercase text-blue-300 sm:text-sm">Winning</span>
								</div>
							</div>

							<div className="animated-product6 card-bg absolute right-[220px] top-[100px] z-10 flex flex-col items-center justify-center overflow-hidden px-0 py-0">
								<div className="py-2">
									<img
										src="/images/landingpage/productResearch6.webp"
										className="w-full max-w-[50px] sm:max-w-[55px]"
										alt="Dropshipping Winning Product"
										width="300"
										height="300"
									/>
								</div>

								<div className="flex w-fit items-center justify-center gap-2 bg-black/60 px-2 py-2">
									<svg className="w-5 fill-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
										<path d="M232,208H213.69L153.42,34.75A16,16,0,0,0,138.31,24H117.69a16,16,0,0,0-15.11,10.74L42.31,208H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM95.43,104h65.14l16.7,48H78.73Z"></path>
									</svg>
									<span className="text-md uppercase text-yellow-400 sm:text-sm">Scaling</span>
								</div>
							</div>
						</div>
					</div>

					<div className="grid items-center gap-20 px-4 md:grid-cols-2">
						<div className="relative mt-16 w-full lg:mt-0">
							<div className="card-bg w-full flex-col rounded-[12px] px-0 backdrop-blur-md sm:max-w-[300px] ">
								<div className="flex items-center gap-2 px-3 pb-1 pt-3">
									<img
										src="/images/logo/illustration.svg"
										className="h-8 w-8 rounded-full"
										alt="PagePilot.ai Logo"
										width="100"
										height="100"
									/>
									<div className="flex flex-col">
										<span className="text-[.8rem] font-semibold text-white">PagePilot.ai</span>
										<span className="text-xs text-gray-DEFAULT-400">Sponsored</span>
									</div>
								</div>
								<div className="font-arial relative flex w-full flex-col gap-2 overflow-hidden px-3 pt-2 text-[.8rem] text-white/80 hover:cursor-pointer">
									<p>
										"From the very first time I slipped my feet into these plush wonders it felt amazing!!! They are
										super comfortable and keep yourself really really warm."
										<span> ⭐⭐⭐⭐⭐ - Emily R. - Canada</span>
									</p>
									<p>✅ Instant Feet Warmth</p>
									<p>✅ Super Stylish</p>
									<p>✅ Snuggle-Worthy Style</p>
									<p>❌ Forget About Cold Feet</p>
									<p>❌ No More Slipping</p>
									<p>Ever since I started working, finding the ultimate comfort for my feet has been a challenge.</p>
									<p>🛍️ Shop Now - Save 40%!</p>
								</div>
								<div className="relative mt-2 w-full overflow-hidden">
									<img
										src="images/landingpage/creativeImage2.webp"
										className="w-full"
										alt="Dropshipping Product Facebook Ads"
										width="300"
										height="300"
									/>
								</div>
								<div className="flex items-center justify-between px-3 pb-3 pt-3">
									<div className="flex w-full max-w-[175px] flex-col">
										<div className="font-arial h-[32px] pr-[5px] text-sm font-medium text-white">
											Step into Warm Coziness! 💖
										</div>
									</div>
									<button className="font-arial w-full max-w-[87px] rounded-[8px] bg-white/10 px-3 py-2 text-[.7rem] font-medium uppercase text-white">
										SHOP NOW
									</button>
								</div>
							</div>

							<div className="card-bg absolute right-0 top-20 hidden w-full max-w-[300px] flex-col rounded-[12px] bg-slate-900/40 px-0 backdrop-blur-lg sm:flex">
								<div className="flex items-center gap-2 px-3 pb-1 pt-3">
									<img
										src="/images/logo/illustration.svg"
										className="h-8 w-8 rounded-full"
										alt="PagePilot.ai Logo"
										width="100"
										height="100"
									/>
									<div className="flex flex-col">
										<span className="text-[.8rem] font-semibold text-white">PagePilot.ai</span>
										<span className="text-xs text-gray-DEFAULT-400">Sponsored</span>
									</div>
								</div>
								<div className="font-arial relative flex w-full flex-col gap-2 overflow-hidden px-3 pt-2 text-[.8rem] text-white/80 hover:cursor-pointer">
									<p>Meet Cosmo Astronaut – your gateway to a stellar experience 🌜</p>
									<p>✅ Sleep well and relax yourself</p>
									<p>✅ Cozy ambiance in your room</p>
									<p>✅ Incredible light show</p>
									<p>Shop Now 🛍️</p>
								</div>
								<div className="relative mt-2 w-full overflow-hidden">
									<img
										src="images/landingpage/creativeImage1.webp"
										className="w-full"
										alt="Dropshipping Product Facebook Ads"
										width="300"
										height="300"
									/>
								</div>
								<div className="flex items-center justify-between px-3 pb-3 pt-3">
									<div className="flex w-full max-w-[175px] flex-col">
										<div className="font-arial h-[32px] pr-[5px] text-sm font-medium text-white">
											✨ Light Up Your Nights with Stars!
										</div>
									</div>
									<button className="font-arial w-full max-w-[87px] rounded-[8px] bg-white/10 px-3 py-2 text-[.7rem] font-medium uppercase text-white">
										SHOP NOW
									</button>
								</div>
							</div>
						</div>

						<div className="flex flex-col space-y-6" id="creatives">
							<Badge type="theme" extra="w-fit" text="Facebook Ad Copy" />
							<div className="text-2xl font-semibold text-white md:text-3xl">
								Create ads that stands out and drive clicks
							</div>
							<p className="text-base text-gray-DEFAULT-400 md:text-lg">
								Leverate the power of PagePilot’s AI to craft ad copy that grabs attention and boosts engagement.
							</p>
							<ul className="flex flex-col gap-6">
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Create eye-catching headlines that demand attention
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Communicate your product's unique value proposition
									</span>
								</li>
								<li className="flex md:items-center">
									<svg
										className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
										viewBox="0 0 12 12"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
									</svg>
									<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
										Optimize ad copy for various platforms and audiences
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<img
					src="/images/landingpage/heroVisual1.webp"
					className="animate-smoothMove absolute -left-60 -top-20 -z-10 max-w-[400px] opacity-40 blur-lg lg:-top-40 3xl:opacity-60"
					alt="PagePilot.ai Decoration"
					width="400"
					height="400"
				/>

				<img
					src="/images/landingpage/heroCilinder.webp"
					className="animate-smoothMove absolute -bottom-28 -right-[200px] -z-10 hidden max-w-[350px] opacity-20 blur-sm sm:flex xl:opacity-100"
					alt="PagePilot.ai Decoration"
					width="350"
					height="350"
				/>
			</div>
		</section>
	);
};

export default Feature2;
